import { Grid } from "@mui/material";
import { getGraphTitle } from "../../../components/GraphCard/functions/getGraphTitle";
import GraphCard from "../../../components/GraphCard/graphCard";
import ImgRefresh from "../../../components/GraphImgRefresh/components/imgRefresh";

function ImgGraph({ graphData, index, handleGraphChange }) {
  return (
    <Grid item md={8} xs={12}>
      <GraphCard
         graphData={graphData}
         title={getGraphTitle(graphData, "dashboard-graph")}
         handleGraphClear={() => handleGraphChange("remove", index)}
         clearable
      >
        <ImgRefresh />
      </GraphCard>
    </Grid>
  );
}

export default ImgGraph;
